import { ProgressBarItemModified } from 'components/ProgressBar/context';

import ProgressBarItemMulti from './ProgressBarItemMulti';
import ProgressBarItemSingle from './ProgressBarItemSingle';

const ProgressBarItem: React.FunctionComponent<ProgressBarItemModified> =
  function (props) {
    const { type } = props;
    if (type === 'multi') return <ProgressBarItemMulti {...props} />;
    return <ProgressBarItemSingle {...props} />;
  };

export default ProgressBarItem;
